<template>
  <div>
   <b-row no-gutters style="display: flex;align-items: center;justify-content: center;">
     <b-col md="12" >
       <b-card
       no-body
         class="overflow-auto card"
         style="padding:0;border-radius:0;"
       >
       
       <div class="panel" style="border-radius:0;">
         <div class="container py-3">
           <div class="row align-items-center">
             <!-- Title -->
              <div class="row" style="width: 100%;padding:10px;">
             <div  class="col-12 col-md-6 text-left text-md-start mb-2 mb-md-0">
               <strong class="text-white font-weight-black font-monospace" style="font-size: 1.3em;">
                 All Transactions
               </strong>
               <span v-if="$store.getters.role === 'Admin'">
                <b-button  class="btn btn-success btn-sm"
                
                v-b-modal="'post-update-modal-expense'"
                @click="resetform()" >Add Transaction</b-button>
              
              </span>
             </div>
           

             <div class="col-12 col-md-6 text-center text-md-start mb-12 mb-md-0" style="color:white;display:flex;justify-content:center;">
              <b-row no-gutters  >
                <b-col md='auto' >
                  <div style="float:left;">
           <label  for="" style="color:white;padding-top:4px;margin-right:5px;">From :</label> <input type="date" name="" id="" placeholder="from" v-model="from" style="border:0.5px solid grey;border-radius: 5px;">
           </div>
                </b-col>
                <b-col md='auto'>
                  <div style="float:left;">
           <label for="" style="color:white;padding-top:4px;margin-right:30px;margin-left:20px;">to :</label><input type="date" name="" id="" placeholder="to" v-model="to" style="border:0.5px solid grey;border-radius: 5px;">
                  </div>
                </b-col>
                <b-col md="auto">
                  <div >
           <b-button class="btn btn-success btn-sm" @click="FilterExpenseDate" style="margin-left:10px; 
           "> Filter</b-button>

            <b-button class="btn  btn-sm" @click="ClearData()" style="margin-left:10px; 
           "> Clear</b-button>
                  </div>
                </b-col>
              </b-row>
              </div>
            </div>
           </div>
         </div>
         
         <div class="panel-body table-responsive">
           <datatable
             :columns="columns"
             :data="expenses.data"
             class="table table-striped text-nowrap table-bordered"
             style="text-align: center; color: white;"
           >
             <template slot-scope="{ row, index }">
               <tr :style="row.state==1?'background:tomato;backdrop-filter: blur(1px) !important;color:white;':(row.state==2?'background: rgba(0, 128, 0, 0.3) !important;backdrop-filter: blur(1px) !important;color:white;':'')">
                 <td class="align-middle">{{ index + 1 }}</td>
                 <td class="align-middle"> <i class="fas fa-comment" @click="ViewNote(row, index)"  v-b-modal="'post-update-modal-note-view'"  :class="{ blink: row.isnote }"
                  :style="{ color: row.isnote ? 'red' : 'white', fontSize: '1.5em' }"></i></td>
                 <td class="align-middle">{{row.agent.username}}</td>
                 <td class="align-middle">{{row.sender}}</td>
                 <td class="align-middle">{{row.reciver}}</td>
                 <td class="align-middle">{{row.phone_number}}</td>
                 <td class="align-middle">{{row.country.country+'('+row.country.currency+')'}}</td>
                 <td class="align-middle">{{formatNumber(row.amount)}}</td>
                 <td style="vertical-align: middle"><span class="badge badge-pill btn-primary"   v-if='row.state==0'>Pending</span><span class="badge badge-pill badge-danger" v-if='row.state==1'>Void</span><span class="badge badge-pill badge-success" v-if='row.state==2'>Paid</span></td>
                 <td class="align-middle">{{ row.created_at | myDate }}</td>
                 <td class="align-middle">
                   <b-dropdown variant="link" no-caret right>
                     <template v-slot:button-content>
                       <i class="fas fa-ellipsis-v text-secondary"></i>
                     </template>
                     <b-dropdown-item @click="Editexpense(row, index)"  v-b-modal="'post-update-modal-expense'" v-if="row.state<2 &&$store.getters.role=='Admin'">
                       <i class="fa fa-eye text-secondary mr-2"></i> View
                     </b-dropdown-item>
                     <b-dropdown-item @click="PaidTransaction(row, index)"  v-b-modal="'post-update-modal-note-view-display'" v-if="row.state==2" >
                      <i class="fa fa-eye text-secondary mr-2"></i> View
                    </b-dropdown-item>
                     <b-dropdown-item @click="PaidTransaction(row, index)" v-if="row.state==0&&$store.getters.role!='Admin'" v-b-modal="'post-update-modal-expense-view'">
                      <i class="fas fa-dollar-sign text-secondary mr-2"></i> Paid
                    </b-dropdown-item>
                     <b-dropdown-item @click="voidtransaction(row.id, index,row.state)" v-if="row.state<2 && $store.getters.role!='Admin'">
                       <i :class="row.state==1?'fas fa-undo text-secondary mr-2':'fas fa-ban text-secondary mr-2'"></i> {{row.state==1?'Restore':'Void'}}
                     </b-dropdown-item>
                     <b-dropdown-item @click="deleteexpense(row.id, index)" v-if="row.state<2 && $store.getters.role=='Admin'">
                      <i class="fas fa-trash-alt text-secondary mr-2"></i> Delete
                    </b-dropdown-item>

                   </b-dropdown>
                 </td>
               </tr>
             </template>
             
           </datatable>
           <template v-if="!expenses.data.length">
            <div class="text-center text-white py-3 w-100">
              <i class="fas fa-database fa-2x text-secondary"></i>
              <p class="mt-2"><strong>No Data Found</strong></p>
              <p>🔍 Try searching again or adding new data.</p>
            </div>
          </template>
         </div>
         
       </div>
         <div style="float:right;">
           <pagination :data="expenses" @pagination-change-page="getmyexpense">
              </pagination>
        </div>
       </b-card>
     </b-col>
   </b-row>
   
    <b-modal :id="'post-update-modal-expense'" :size="'md'">
         <div style="padding-left:20px;padding-top:15px;padding-bottom:5px;border-bottom:1px solid rgba(214,214,214);font-size:1.3em;">{{display?'Update Transaction':'Add Transaction'}} <span><i class="fas fa-times" style="float:right;margin-right:20px;margin-top:5px;color:grey;" @click="closemoadl('post-update-modal-expense')"></i></span></div>
     <form
        style="padding:30px;padding-top:15px;margin-bottom:35px;"
       @submit.prevent="display ? update() : create()"
     >
      <div class="form-group row">
        <label>Sender</label>
        <input
         required
           v-model="expense.sender"
           name="sender"
           placeholder="full name"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('sender') }"
         >
        <has-error :form="expense" field="sender"></has-error>
      </div>
      <div class="form-group row">
        <label>Reciver</label>
        <input
         required
           v-model="expense.reciver"
           name="reciver"
           placeholder="Full Name"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('reciver') }"
         >
        <has-error :form="expense" field="reciver"></has-error>
      </div>
      <div class="form-group row">
        <label>Phone Number</label>
        <input
         required
           v-model="expense.phone_number"
           name="phone_number"
           placeholder="phone Number"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('phone_number') }"
         >
        <has-error :form="expense" field="phone_number"></has-error>
      </div>
      <div class="form-group row">
        <label>Country</label>
        <select
        required
          v-model="expense.country"
          @change="updateuserholder"
          name="country"
          placeholder="country"
          class="form-control"
          :class="{ 'is-invalid': expense.errors.has('country') }"
        >
       <option value="">Select country</option>
       <option :value="contry.id" v-for="contry in countrys" :key="contry.id">{{contry.country}}</option>
       </select>
        <has-error :form="expense" field="country"></has-error>
      </div>
      <div class="form-group row">
        <label>Agent</label>
        <select
        required
          v-model="expense.user_id"
          name="user_id"
          placeholder="agent"
          class="form-control"
          :class="{ 'is-invalid': expense.errors.has('user_id') }"
        >
       <option value="">Select agent</option>
       <option :value="contry.id" v-for="contry in users_holder" :key="contry.id">{{contry.username}}</option>
       </select>
        <has-error :form="expense" field="country"></has-error>
      </div>
       <div class="form-group row">
         <label>Amount</label>
         <input
         required
           v-model="expense.amount"
           name="amount"
           placeholder="amount"
           class="form-control"
           :class="{ 'is-invalid': expense.errors.has('amount') }"
         />
         <has-error :form="expense" field="amount"></has-error>
       </div>
        
      

      
       <div  style='border-top:1px solid rgba(0.5,0.5,0.5,0.3);padding-top:10px;margin-top:15px;'>
       <div class="float-right" >
         <b-button type="submit"  class="btn-primary" v-if="!display">
           Save
         </b-button>
         <b-button type="submit" class="btn-primary" v-if="display">
           Update
         </b-button>
       </div>
       </div>
     </form>
   </b-modal>



   <b-modal :id="'post-update-modal-expense-view'" :size="'lg'" v-if="activedata.id">
    <div style="padding-left: 20px; padding-top: 15px; padding-bottom: 5px; border-bottom: 1px solid rgba(214, 214, 214); font-size: 1.3em;">
      Note 
      <span>
        <i class="fas fa-times" 
           style="float: right; margin-right: 20px; margin-top: 5px; color: grey;" 
           @click="closemoadl('post-update-modal-expense-view')">
        </i>
      </span>
    </div>
    <div class="body" style="padding:10px;">
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <div>
            <strong>Sender</strong>
            <div>{{activedata.sender}}</div>
        </div>
        <div>
            <strong>Reciver</strong>
            <div>{{activedata.reciver}}</div>
        </div>
        <div>
            <strong>Phone Number</strong>
            <div>{{activedata.phone_number}}</div>
        </div>
       
    </div>
   
      <div>
        <form
        style="padding:30px;padding-top:15px;margin-bottom:35px;"
       @submit.prevent="Pay()"
     >
     
       
       <div class="form-group row" v-if="activedata.state==0">
          <label for="">Attachement (Optional)</label>
        <input
   style="box-shadow:none;padding-bottom:40px;font-size:100%;"
   class="form-control login-input"
      @change="attachmentprocessor"
     name="attachement"
     type="file"
     tabindex="1"
     autocomplete="off"
   />       
  
    <has-error :form="expense" field="attachement" style="color:red;"></has-error>
  <img :src="this.url" v-if="url" alt="" style="width:100%;margin-top:10px;">
  </div>
      
       <div  style='border-top:1px solid rgba(0.5,0.5,0.5,0.3);padding-top:10px;margin-top:15px;'>
       <div class="float-right">
         <b-button type="submit" class="btn-primary" v-if="activedata.state==0">
           Paid
         </b-button>
       </div>
       </div>
     </form>
      </div>
    </div>
  </b-modal>

  <b-modal :id="'post-update-modal-note-view'" :size="'lg'" v-if="holder.id">
    <div style="padding-left: 20px; padding-top: 15px; padding-bottom: 5px; border-bottom: 1px solid rgba(214, 214, 214); font-size: 1.3em;">
      Note 
      <span>
        <i class="fas fa-times" 
           style="float: right; margin-right: 20px; margin-top: 5px; color: grey;" 
           @click="closemoadl('post-update-modal-note-view')">
        </i>
      </span>
    </div>
    <div class="body" style="padding:10px;">
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <div>
            <strong>Sender</strong>
            <div>{{holder.sender}}</div>
        </div>
        <div>
            <strong>Reciver</strong>
            <div>{{holder.reciver}}</div>
        </div>
        <div>
            <strong>Phone Number</strong>
            <div>{{holder.phone_number}}</div>
        </div>
       
    </div>
      <textarea name="" id="" rows="10" class="form-control" disabled style="margin-top:10px;" :value="holder.note.replace(/\\n/g, '\n')"></textarea>
      <input placeholder="writhe message.." type="text" v-model="note" class="form-control" style="margin-top: 20px;">
      <div style="margin-top: 10px;display:flex;justify-content:center;" v-if="holder.state!=2">
        <button class="btn btn-sm btn-success" style="margin-right: 10px;" @click="SendNote()">Send</button>
        <button class="btn btn-sm btn-danger" @click="closemoadl('post-update-modal-note-view')">Close</button>
      </div>
    </div>
    
  
   
  </b-modal>

  <b-modal :id="'post-update-modal-note-view-display'" :size="'lg'" v-if="activedata.id">
    <div style="padding-left: 20px; padding-top: 15px; padding-bottom: 5px; border-bottom: 1px solid rgba(214, 214, 214); font-size: 1.3em;">
      Note 
      <span>
        <i class="fas fa-times" 
           style="float: right; margin-right: 20px; margin-top: 5px; color: grey;" 
           @click="closemoadl('post-update-modal-note-view-display')">
        </i>
      </span>
    </div>
    <div class="body" style="padding:10px;">
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <div>
            <strong>Sender</strong>
            <div>{{activedata.sender}}</div>
        </div>
        <div>
            <strong>Reciver</strong>
            <div>{{activedata.reciver}}</div>
        </div>
        <div>
            <strong>Phone Number</strong>
            <div>{{activedata.phone_number}}</div>
        </div>
       
    </div>
     <div>
      <label for="" style="margin:10px;">Attachement</label><br>
      
      <img :src="'https://my.flylikeeagle.com/backend/public/storage/uploads/images/' + activedata.image"  alt=""  style="max-width: 100%; height: auto;">
     </div>
    </div>
    
  
   
  </b-modal>
  
  
 </div>
</template>
<script>
export default {
 data() {
   return {
    note:'',
    active_index:-1,
    currency:{'et':'ETB','us':'USD','au':'AUD'},
    selectedFile: "Upload Transaction Recipt",
    recivers:[],
    countrys:[],
    recivers_h:[],
     form:new window.Form({
     search:''
           }),
     updateindex:-1,
     columns: [
       { label: "No" },
       { label: "Note" },
       { label: "Agent" },
       { label: "Sender" },
       { label: "Reciver" },
       { label: "Phone Number" },
       { label: "Currency" },
       { label: "Amount" },
       { label: "State" },
        { label: "Created At", field: "created_at" },
       { label: "Manage" },
     ],
     holder:{},
     activedata:{},
     from:'',
     to:'',
     exchange_rate:0,
     total_payable:0,
     from_cur:'',
     to_cur:'',
     expenses: {data:[]},
     rates:[],
     active_id:0,
     user:{},
     tfs:[],
     users:[],
     display: false,
     url: "",
     title:'',
     fee:'',
     code:'',
     selected_titles:[],
     isedit:-1,
     users_holder:[],
     expense: new window.Form({
       sender: "",
       attachment:'',
       reciver:'',
       country:'',
       user_id:'',
       amount:0,
       phone_number:'',
       id: "",
     }),
   };
 },
 beforeMount() {
   this.getmyexpense()
   this.getcountry()
   this.getAllUsers()
 },
 methods: {
  SendNote(){
    this.$store.dispatch('admin/AdminController',{'data':{note:this.note},'method':'post','api':'admin_update_note','variable':'expense','params':this.holder.id}, { root: true }).then(() => {
        window.Toast.fire({
           icon: "success",
           title:'Note Sent successfuly',
         });
         var val=this.$store.getters["admin/Getexpense"];
         this.note=''
       this.expenses.data[this.active_index].note=val
       this.holder.note=val
     }).catch(()=>{
        window.Toast.fire({
           icon: "error",
           title:"Note can't be Sent !!",
         });
     })
  },
  ViewNote(row,index){
    this.active_index=index
    this.holder=row
    this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_update_note_status','variable':'users','params':row.id}, { root: true }).then(() => {
      var val=this.$store.getters["admin/Getexpense"];
       this.expenses.data[this.active_index].isnote=val.isnote
       this.expenses.data[this.active_index].isnote_a=val.isnote_a
      
      })
   
  },
  formatNumber(value) {
    if (!value) return '0';
    return new Intl.NumberFormat('en-US').format(value);
  },
  PaidTransaction(row,index){
    this.url=''
    this.attachment=''
    this.activedata=row
    this.active_index=index
  },
  Pay(){
    var form =window.VFToFD(this.expense);
    window.Swal.fire({
           title: 'are you sure',
           text: 'you want to Pay this Transaction',
           icon: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
           confirmButtonText: 'Yes'
         }).then((result) => {
           if (result.value) {
             this.$store.dispatch('admin/AdminController',{'data':form,'method':'post','api':'admin_pay_transaction','variable':'expense','params':this.activedata.id}, { root: true }).then(() => {
        window.Toast.fire({
           icon: "success",
           title:'Transaction Paid successfuly',
         });
         this.closemoadl('post-update-modal-expense-view')
       this.expenses.data[this.active_index].image=this.$store.getters["admin/Getexpense"];
       this.expenses.data[this.active_index].state=2;
     }).catch(()=>{
        window.Toast.fire({
           icon: "error",
           title:"Transaction can't be Paid !!",
         });
     })
           }
    });
  },
voidtransaction(id,index,state) {
     window.Swal.fire({
           title: 'are you sure',
           text: state==1?'you want to Void this Transaction':'you want to Restore this Transaction',
           icon: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
           confirmButtonText: 'Yes'
         }).then((result) => {
           if (result.value) {
             this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_reject_transaction','variable':'status','params':id}, { root: true }).then(() => {
        window.Toast.fire({
           icon: "success",
           title:state==1?'Transaction void successfuly':'Transaction Restored successfuly',
         });
       this.expenses.data[index].state=(this.expenses.data[index].state==1?0:1)
     }).catch(()=>{
        window.Toast.fire({
           icon: "error",
           title:"Transaction can't be Voided !!",
         });
     })
           }
    });
   },
  updateuserholder(e){
    var id=e.target.value
    this.users_holder=[]
    this.users.forEach(element => {
      if(element.country.id==id){
        this.users_holder.push(element)
      }
    });
  },
  getAllUsers(page=1) {
      this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_users','variable':'users','params':'?page='+page}, { root: true }).then(() => {
        this.users=this.$store.getters['admin/Getusers'].data
      })
    },
  ClearData(){
    this.from=''
    this.to=''
    var e={'target':{'value':0}};
    this.FilterExpense(e)
  },
  
  FilterExpenseDate(){
    var api='admin_filter_transaction'
    if(this.$store.getters.role=="Admin")
    api='admin_filter_transaction_admin'
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to},'method':'post','api':api,'variable':'expense','params':''+this.active_id}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
  },
  UpdateRecivable(){
    this.expense.recivable=this.exchange_rate*this.expense.amount
    
  },
  getmyexpensefee(page=1) {
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_inc','variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.tfs=this.$store.getters['admin/Getexpense'].data
     })
   },
  UpdateReciver(e){
    var holder=JSON.parse(e.target.value)
    this.exchange_rate=holder.rate
    this.expense.reciver=holder.to.id
    this.from_cur=this.currency[holder.from.code]
    this.to_cur=this.currency[holder.to.code]
    this.UpdateRecivable()
  },
  getmyexpenserate(page=1) {
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_rate','variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.rates=this.$store.getters['admin/Getexpense'].data
     })
   },
  FilterCountry(){
    this.recivers_h=[]
    this.rates.forEach(element => {
      if(this.expense.sender==element.sender){
        this.recivers_h.push(element)
      }
    });
  },
 
    attachmentprocessor (e) {
      var photos = e.target.files[0]
      var file = photos
      var limit = 1024 * 1024 * 2
      if (file.size <= limit) {
        this.expense.attachment = file
        this.selectedFile = file ? file.name : "Upload Your ID";
        this.url = URL.createObjectURL(file)
      }
    },
  getcountry(){
    this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_expense','variable':'expense'}, { root: true }).then(() => {
      this.countrys=this.$store.getters['admin/Getexpense'].data
       
      })
  },
   FilterExpense(e){
    console.log(e)
    var id =e.target.value
    if(id){
      this.active_id=id
      this.$store.dispatch('admin/AdminController',{'data':{},'method':'post','api':'admin_filter_transaction','variable':'expense','params':id}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
    }else{
      this.active_id=0
      this.getmyexpense()
    }
   },
   closemoadl(val){
     this.$bvModal.hide(val)
   },
   resetform() {
     this.expense.reset();
     this.url = "";
     this.display=false
     this.updateindex=-1
   },
   getimage(image){
     return window.image_url+image
   },
   Editexpense(expense,index) {
    this.updateindex=index
    this.display=true
    var id=expense.country.id
    this.users_holder=[]
    this.users.forEach(element => {
      if(element.country.id==id){
        this.users_holder.push(element)
      }
    });
     this.expense.fill(expense)
     this.expense.user_id=expense.agent.id
     this.expense.country=expense.country.id
   },
   getmyexpense(page=1) {
    var api='admin_get_transaction'
    if(this.$store.getters.role=="Admin")
    api='admin_get_transaction_admin'
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':api,'variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
   },
   getUserProfile(){
         this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_my_profile','variable':'users'}, { root: true }).then(() => {
        this.user=this.$store.getters['admin/Getusers']
      })
      },
   deleteexpense(id,index) {
     window.Swal.fire({
           title: 'are you sure',
           text: 'you want to delete this Transaction',
           icon: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
           confirmButtonText: 'Yes'
         }).then((result) => {
           if (result.value) {
             this.$store.dispatch('admin/AdminController',{'data':{},'method':'delete','api':'admin_delete_transaction','variable':'status','params':id}, { root: true }).then(() => {
        window.Toast.fire({
           icon: "success",
           title:'Transaction deleted successfuly',
         });
       this.expenses.data.splice(index,1)
     }).catch(()=>{
        window.Toast.fire({
           icon: "error",
           title:"Transaction can't be deleted !!",
         });
     })
           }
    });
   },
   update() {
    var form =window.VFToF(this.expense);

     this.$store
       .dispatch('admin/AdminController',{'data':form,'method':'post','api':'admin_update_transaction','variable':'expense','params':form.id}, { root: true })
       .then(() => {

         var data = this.$store.getters["admin/Getexpense"];
         this.expenses.data[this.updateindex].id=data.id
         this.expenses.data[this.updateindex].sender=data.sender
         this.expenses.data[this.updateindex].phone_number=data.phone_number
         this.expenses.data[this.updateindex].reciver=data.reciver
         this.expenses.data[this.updateindex].country=data.country
         this.expenses.data[this.updateindex].agent=data.agent
         this.expenses.data[this.updateindex].amount=data.amount
         this.expenses.data[this.updateindex].created_at=data.created_at
         this.display = false;
         this.$bvModal.hide("post-update-modal-expense");
          window.Toast.fire({
           icon: "success",
           title:'Transaction updated successfuly',
         });
       })
       .catch((err) => {
         this.expense.errors.errors = err;
       });
   },
   create() {
     var form =window.VFToFD(this.expense);
     this.$store.dispatch('admin/AdminController',{'data':form,'method':'post','api':'admin_create_transaction','variable':'expense'}, { root: true }).then(() => {
         this.getmyexpense()
         this.display = false;
         this.$bvModal.hide("post-update-modal-expense");
         window.Toast.fire({
           icon: "success",
           title:'Transaction created successfuly',
         });
       })
       .catch((err) => {
         this.expense.errors.errors = err;
       });
   }
 },
};
</script>

<style scoped>
.search-controller{
 border-left:0;
 border-top-right-radius: 10px;
 border-bottom-right-radius: 10px;
}
::placeholder {
color: black;
 font-style: italic;
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 font-size: 1em;
}
.grade-icon{
 color:#fbcf00;
 font-size: 1.5em;
}

.close{
   color:blacksmoke;
   opacity: 1;
}

.card {
 position: relative;
   display: flex;
   flex-direction: column;
   min-width: 0;
   word-wrap: break-word;
   background-color:white;
   background-clip: border-box;
   border: 0 solid #d9dee3;
   border-radius: 0.5rem;
}
.bg-gradient-danger{
 border-radius: 5px !important;
}
.bg-gradient-danger:hover{
 background:transparent !important;
 color:white;
}
.bg-gradient-danger:hover .top-1{
  position: relative;
 visibility:visible;
 top:0;
 width:100%;
 border:0;
 border-top:1.5px solid blue;
}
.bg-gradient-danger:hover .top-2{
position: relative;
 visibility:visible;
 bottom:0;
 float:right;
 width:100%;
 border-bottom:1.5px solid blue;  
}
.top-1{
 position: relative;
 visibility:hidden;
 top:0;
 width:20%;
 border:0;
 z-index: 0;
 border-top:1px solid blue;
 transition: all 0.700s;
 padding-bottom: 10px;
}
.top-2{
 position: relative;
 z-index: 0;
 visibility:hidden;
 bottom:0;
 float:right;
 width:20%;
 border:0;
 border-bottom:1px solid blue;
 transition: all 0.700s;
 padding-top:10px;
}


.panel{
    /*background: linear-gradient(to right, #570827,#2b0112);*/
    background:  linear-gradient(to top, #013447, #203a43, #013447);

 padding: 0;
 border-radius: 10px;
 border: none;
 box-shadow: 0 0 0 5px rgba(0,0,0,0.05),0 0 0 10px rgba(0,0,0,0.05);
}
.panel .panel-heading{
 padding: 20px 15px;
 border-radius: 10px 10px 0 0;
 margin: 0;
}
.panel .panel-heading .title{
 color: #fff;
 font-size: 28px;
 font-weight: 500;
 text-transform: capitalize;
 line-height: 40px;
 margin: 0;
}
.panel .panel-heading .btn{
 color: rgba(255,255,255,0.5);
 background: transparent;
 font-size: 16px;
 text-transform: capitalize;
 border: 2px solid #fff;
 border-radius: 50px;
 transition: all 0.3s ease 0s;
}
.panel .panel-heading .btn:hover{
 color: #fff;
 text-shadow: 3px 3px rgba(255,255,255,0.2);
}
.panel .panel-heading .form-control{
 color: #fff;
 background-color: transparent;
 width: 35%;
 height: 40px;
 border: 2px solid #fff;
 border-radius: 20px;
 display: inline-block;
 transition: all 0.3s ease 0s;
}
.panel .panel-heading .form-control:focus{
 background-color: rgba(255,255,255,0.2);
 box-shadow: none;
 outline: none;
}
.panel .panel-heading .form-control::placeholder{
 color: rgba(255,255,255,0.5);
 font-size: 15px;
 font-weight: 500;
}
.panel .panel-body{ padding: 0; }
.panel .panel-body .table thead tr th{
 color: #fff;
 background-color: rgba(255, 255, 255, 0.2);
 font-size: 12px;
 font-weight: 500;
 text-transform: uppercase;
 padding: 1px;
}
.panel .panel-body .table tbody tr td{
 color: #fff;
 font-size: 15px;
 padding: 10px 12px;
 vertical-align: middle;
}
.panel .panel-body .table tbody tr:nth-child(even){ background-color: rgba(255,255,255,0.05); }
.panel .panel-body .table tbody .action-list{
 padding: 0;
 margin: 0;
 list-style: none;
}
.panel .panel-body .table tbody .action-list li{
 display: inline-block;
 margin: 0 5px;
}
.panel .panel-body .table tbody .action-list li a{
 color: #fff;
 font-size: 15px;
 position: relative;
 z-index: 1;
 transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:hover{ text-shadow: 3px 3px 0 rgba(255,255,255,0.3); }
.panel .panel-body .table tbody .action-list li a:before,
.panel .panel-body .table tbody .action-list li a:after{
 content: attr(data-tip);
 color: #fff;
 background-color: #111;
 font-size: 12px;
 padding: 5px 7px;
 border-radius: 4px;
 text-transform: capitalize;
 display: none;
 transform: translateX(-50%);
 position: absolute;
 left: 50%;
 top: -32px;
 transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:after{
 content: '';
 height: 15px;
 width: 15px;
 padding: 0;
 border-radius: 0;
 transform: translateX(-50%) rotate(45deg);
 top: -18px;
 z-index: -1;
}
.panel .panel-body .table tbody .action-list li a:hover:before,
.panel .panel-body .table tbody .action-list li a:hover:after{
 display: block;
}
.panel .panel-footer{
 color: #fff;
 background-color: transparent;
 padding: 15px;
 border: none;
}
.panel .panel-footer .col{ line-height: 35px; }
.pagination{ margin: 0; }
.pagination li a{
 color: #fff;
 background-color: transparent;
 border: 2px solid transparent;
 font-size: 18px;
 font-weight: 500;
 text-align: center;
 line-height: 31px;
 width: 35px;
 height: 35px;
 padding: 0;
 margin: 0 3px;
 border-radius: 50px;
 transition: all 0.3s ease 0s;
}
.pagination li a:hover{
 color: #fff;
 background-color: transparent;
 border-color: rgba(255,255,255,0.2);
}
.pagination li a:focus,
.pagination li.active a,
.pagination li.active a:hover{
 color: #fff;
 background-color: transparent;
 border-color: #fff;
}
.pagination li:first-child a,
.pagination li:last-child a{
 border-radius: 50%;
}
@media only screen and (max-width:767px){
 .panel .panel-heading .title{
     text-align: center;
     margin: 0 0 10px;
 }
 .panel .panel-heading .btn_group{ text-align: center; }
}
.blink {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>